import { getAllUrlParams } from '@hll/driver-js-utils';
import { isInAppFn } from '@/common/tools';
import watchdog from '@xl/watch-dog-jsutil';
import ua from '@xl/user-agent';
import { ClientUtil } from '@xl/js-utils';
import { CoupeSDK } from '@xl/coupe-sdk';

const state = {
  // 合并所有携带的 url 参数，包含 search 参数和 hash 参数
  urlParams: {
    driver_fid: null,
    platform_type: null,
    trigger_coordinates: null,
    token: null,
  },
  // app 版本号，默认 0
  revision: 0,
  useH5Title: false,
  scrollHeight: 0,
  // 是否在端内
  isInApp: false,
  // app版本信息
  appInfo: {},
  pageShow: true, // 页面是否显示，默认是显示的
  coupledData: {},
};

// getters
const getters = {
  urlParams(state) {
    return state.urlParams;
  },
  revision(state) {
    return state.revision;
  },
  useH5Title(state) {
    return state.useH5Title;
  },
  isInApp(state) {
    return state.isInApp;
  },
  appInfo(state) {
    return state.appInfo;
  },
};

// actions
const actions = {
  initAppStore({ commit, dispatch }) {
    // 合并所有 url 参数，hash 前的参数权重最高
    const allUrlParams = getAllUrlParams(window.location.href);
    const { revision, hide_title } = allUrlParams;

    // 是否在app内
    const isInApp = isInAppFn(); // 是否在端内
    console.log('isInApp:' + isInApp);
    console.log(navigator.userAgent);
    commit('setIsInApp', isInApp);
    ClientUtil.webcall({ action: 'getAppInfo' }, (res) => {
      console.log('setAppInfo', JSON.parse(res));
      commit('setAppInfo', JSON.parse(res));

      // 测试 ua 识别的准确率
      const uaRes = ua.parse();
      watchdog.sendEvent('ua.parse.app', uaRes.isInApp, uaRes.is_xl_driver_app, JSON.stringify(uaRes), res);
    });

    // 版本号
    if (revision) {
      commit('setRevision', revision);
    }

    // 缓存所有url参数
    commit('setUrlParams', allUrlParams);

    // 是否隐藏 H5 标题
    if (!revision && !hide_title) {
      // app 小程序 隐藏参数 均不用 H5 导航栏
      commit('setUseH5Title', true);
    }
    dispatch('GetCoupeData');
  },
  GetCoupeData({ commit }) {
    const sdk = new CoupeSDK({
      coupeId: '0d2116ff684d4c5196754051c66e09b0',
    });

    sdk.setConfig({
      fetchMode: 'script',
    });

    sdk.fetch().then((data) => { commit('setCoupledData', data); });
  },
};

// mutations
const mutations = {
  setUrlParams(state, urlParameters) {
    state.urlParams = urlParameters;
  },
  setRevision(state, revision) {
    state.revision = Number.parseInt(revision);
  },
  setUseH5Title(state, useH5Title) {
    state.useH5Title = useH5Title;
  },
  setScrollHeight(state, scrollHeight) {
    state.scrollHeight = scrollHeight;
  },
  setIsInApp(state, isInApp) {
    state.isInApp = isInApp;
  },
  setAppInfo(state, appInfo) {
    state.appInfo = appInfo;
  },
  // 设置保存于app的参数
  setAppVal(state, options) {
    for (const key in options) {
      state[key] = options[key];
    }
  },

  setCoupledData(state, coupledData) {
    console.log('coupledData', coupledData);
    state.coupledData = coupledData;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
